module.exports = __webpack_public_path__ + "img/RS2825RP+.c9c8cb25.png";